import { VizContainerProps } from "../VizContainer";
import "../../Viz.scss";
import { useView } from "../../../../hooks/useView";
import { useDispatch } from "react-redux";
import { actionCreators } from "../../../../store/analytics/Analytics";
import Select from "react-select";
import { useGetFiltersForProjectQuery } from "../../../../store/api/kinesense";
import { useEffect, useState } from "react";
import { FilterSet } from "cloud-core/filters/FilterSet";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button, Form } from "react-bootstrap";

export type VizFiltersProps = VizContainerProps;

export function VizFilters(props: VizFiltersProps) {
    const { view } = useView(props.viewId);
    const dispatch = useDispatch();
    const { data: savedFilters } = useGetFiltersForProjectQuery(
        { projectId: view?.projectId ?? "" },
        { skip: !view?.projectId },
    );
    const [filterOptions, setFilterOptions] = useState<{ value: string; label: string }[]>([]);
    const [selectedFilter, setSelectedFilter] = useState<{ value: string; label: string } | undefined>(undefined);
    const [filterName, setFilterName] = useState<string>("");
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        if (savedFilters && Array.isArray(savedFilters)) {
            const options = savedFilters.map((filter) => ({
                value: filter.filterSetId,
                label: filter.name || filter.filterSetId,
            }));
            setFilterOptions(options);
            console.log("Loaded saved filters:", options);
        }
    }, [savedFilters]);

    if (view?.currentDataDescription === undefined) {
        return;
    }

    const handleSaveFilter = () => {
        setIsModalVisible(true);
    };

    const handleSubmitSaveFilter = (event: React.FormEvent) => {
        event.preventDefault();

        const nameToSave = filterName.trim();

        dispatch(actionCreators.saveViewFilter(props.viewId, nameToSave));
        setFilterName(""); // Clear the input after saving
        setIsModalVisible(false);
    };

    const handleFilterChange = (option: { value: string; label: string } | null) => {
        if (option && savedFilters) {
            setSelectedFilter(option);
            const filterSet = (savedFilters as FilterSet[]).find((f) => f.filterSetId === option.value);
            if (filterSet) {
                dispatch(actionCreators.loadViewFilter(props.viewId, filterSet));
            }
        }
    };

    return (
        <div className="viz-filters viz-panel">
            <h2>Filter</h2>
            <div>
                {view !== undefined &&
                    view?.data.state == "loaded" &&
                    Object.entries(view.currentDataDescription.filters).map(([id, filter]) => {
                        return (
                            <div className="viz-filter" key={id}>
                                <h3>{filter.displayName}</h3>
                                {filter.createComponent(id, view)}
                            </div>
                        );
                    })}
            </div>
            <div>
                <div className="filter-controls">
                    <div className="filter-select-container">
                        <Select
                            classNamePrefix="react-select"
                            options={filterOptions}
                            onChange={handleFilterChange}
                            value={selectedFilter}
                            placeholder="Select a saved filter..."
                            menuPlacement="top"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderBottomRightRadius: "0 !important",
                                    borderTopRightRadius: "0 !important",
                                }),
                            }}
                            isClearable
                        />
                    </div>
                    <button className="btn btn-secondary" onClick={handleSaveFilter} style={{ whiteSpace: "nowrap" }}>
                        <FontAwesomeIcon
                            style={{ marginBottom: "1px", marginLeft: "-1px", marginRight: "1px" }}
                            icon={faFloppyDisk}
                        />
                    </button>
                </div>

                <Modal
                    show={isModalVisible}
                    onHide={() => setIsModalVisible(false)}
                    backdrop="static"
                    keyboard={false}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Save Filter Set</Modal.Title>
                    </Modal.Header>

                    <Form onSubmit={handleSubmitSaveFilter}>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>Filter SetName</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    minLength={3}
                                    placeholder="Enter filter name"
                                    value={filterName}
                                    onChange={(e) => setFilterName(e.target.value)}
                                    autoFocus
                                />
                            </Form.Group>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button type="submit" variant="success">
                                Save Filter
                            </Button>
                            <Button type="button" variant="secondary" onClick={() => setIsModalVisible(false)}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        </div>
    );
}
